import { Box } from "@mui/material";
import React from "react";
import {
  Buttons,
  Gallery,
  Highlights,
  Price,
  TopDrawer,
  useActiveUnit,
} from ".";
import { useUnitHighlight } from "./hooks";
import OpenHouse from "./OpenHouse";
import { getFocus, useAtom, useGet } from "state/jotai";
import { get, label } from "components/Favorites/Favorites.Utilities";
import { _drawer, active_project, drawer_animation_done} from 'state/store.global'
import { PoweredBy } from "components/PoweredBy/PoweredBy";
import DropdownProperties from "./DropdownProperties";
import { useBreak } from "hooks/useBreak";
import { Scrollbar } from "react-scrollbars-custom";
import { useLocation } from "react-router-dom";
import { _bootstrap } from "state/store.bootstrap";
import NewReservationButton from "./NewReservationButton";
import { isIframeMode } from "logging/logging";
import { useToggle } from "hooks/useToggle";

function UnitDrawer() {
  const here = useLocation().pathname;
  const { pin, pid }         = useGet(active_project);
  const unit = useActiveUnit();
  const iFrameEnabled = isIframeMode()
  const highlights = useUnitHighlight(unit);
  const unitId = parseInt(unit.getId());
  const status = unit.getStatus();
  const address = unit.getAddress();
  const moveindate = unit.getMoveInDate();
  const townAndZipcode = unit.getTownZipCode();
  const topicCode = unit?.data?.Data?.Egen_emne_kode?.Value

  const { overlayState } = useToggle();
  const isRent = unit.isRent();
  const price = unit.getPrice();
  const Pris = unit.getPris();

  const properties = unit.getProperties();
  const availableUnits = unit?.data?.Data?.UnitStatusID?.Value === 10;
  const availablePris = unit?.data?.Data?.Pris_Tekst_DK?.Value === "";
 const Text = unit?.getUnitText();
//  console.log(Text,"slls")
//   const filteredProperties = properties.flatMap((property) => {
//       // remove entire økonomi group
//       if (!availablePris && property.order === 20) {
//         return [];
//       }

//       let filteredData = property.data;

//       // availablePris rules
//          if (availablePris && property.order === 20) {
//   filteredData = isRent
//     // Rent: show PropertyID between 100 and 199
//     ? property.data.filter(
//         (item) => item.PropertyID >= 100 && item.PropertyID <= 199
//       )
//     // Sales: show PropertyID between 200 and 299
//     : property.data.filter(
//         (item) => item.PropertyID >= 200 && item.PropertyID <= 299
//       );
// }
//       // remove empty faciliteter group
//       const shouldRemoveOrder40 =
//         property.order === 40 &&
//         !filteredData.some((item) => item.Value !== false);

//       if (shouldRemoveOrder40) {
//         return [];
//       }

//       return [
//         {
//           ...property,
//           data: filteredData,
//         },
//       ];
//     });
const filteredProperties = properties.flatMap((property) => {
  // remove entire økonomi group
  if (!availablePris && property.order === 20) {
    return [];
  }

  let filteredData = property.data;

  // availablePris rules
  if (availablePris && property.order === 20) {
    filteredData = isRent
      // Rent: show PropertyID between 100 and 199
      ? property.data.filter(
          (item) => item.PropertyID >= 100 && item.PropertyID <= 199
        )
      // Sales: show PropertyID between 200 and 299
      : property.data.filter(
          (item) => item.PropertyID >= 200 && item.PropertyID <= 299
        );
  }

  // Hide the entire order if ALL data items have Value === false
  const allValuesAreFalse =
    filteredData.length > 0 &&
    filteredData.every((item) => item.Value === false);

  if (allValuesAreFalse) {
    return [];
  }

  return [
    {
      ...property,
      data: filteredData,
    },
  ];
});
  const filterHighlights = highlights.filter((highlight) => {
   
    if(highlight?.value )
      return true
    
    // if (salestype?.Value === "Lejlighed" && highlight.value   ) {
    //   return highlight.property !== "Uderum"
      
    // } else if (salestype?.Value === "Rækkehus" && highlight.value ) {
    //   return highlight.property !== "Etage_Text";
    // }
  });
  
  const isDrawerAnimating = useAtom(drawer_animation_done)[0];
  const isMobile = useBreak('md_dn')
  const drawer   = useAtom(_drawer)[0] 
  const isDetail = overlayState.detail
  const thumbnails =unit.getThumb()
  const images =  unit.getImages() 
  const unitNo = unit?.data?.Data?.NPV_Projektnr?.Value

  const projectType = getFocus(_bootstrap, "type");
  const today = moveindate;

  // Specify Danish as the locale and customize options
  const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
  const danishFormattedDate = today;

  return (
    <Box
      sx={{
        width: "100%",
         height: isMobile
  ? `calc(100% - ${iFrameEnabled ? "0px" : "73px"})`
  : `calc(100% - ${iFrameEnabled ? "76px" : "157px"})`,
        backgroundColor: "#ffffff",
        overflowY: "auto",
        scrollbarWidth: "none",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        borderLeft:`1px solid ${clr?.primary}`,
      }}
    >
        <Scrollbar trackYProps={{
          renderer: (props) => {
            const { elementRef, ...restProps } = props;
            return <span {...restProps} ref={elementRef}
            className="trackY" />;
          },
        }}
        contentProps={{
          renderer: (props) => {
            const { elementRef, ...restProps } = props;
            return <span {...restProps} ref={elementRef} style={{ height: "100%", display: "block" }} className="Content" />;
          },
        }}
        >
      <Box sx={{ display: 'flex', flexDirection: "column", height: "100%", justifyContent: "space-between" }}>
      <div>
        <Box sx={{position:"relative", zIndex:2}}>
        <TopDrawer
          availableDate={danishFormattedDate}
          address={`${address}, ${townAndZipcode}`}
          topicCode={topicCode}
          statusText={status.label}
          statusId={status.id}
          backgroundColor={status.color}
          textColor="#ffffff"
        />
        </Box>
        <Box sx={{position:"relative",top:"-4px", zIndex:1, background: 'white'}}>
        <Gallery isDetail={isDetail} unitId={unitId} images={images} thumbImg={thumbnails} UnitDrawer width = {isMobile ? ' 100%' : '375px'}  height = {isMobile ? '273px' : '273px'} />

        </Box>
        <Buttons unitData={unit?.data}  unitId={unitId} address={ (address || townAndZipcode ) ? `${address}, ${townAndZipcode}` : ""} rent={price} highlights={highlights} />

        <OpenHouse />

        <Box sx={{  mt: 3 }}>
            <Highlights items={filterHighlights} />

          <Box
            sx={{
              mt: { md: 3, xs: 2 },
              textAlign: "center",
            }}
          >
            <Price
              label={availablePris && (
                isRent
                  ? `${get(unit.data, "LejelejlighedsText")}`
                  : `${label(unit.data, "Kontantpris")}`)
              }
              value={(availablePris && price) ? price : ""}
            />
          </Box>
          {/* <ReservationButton unit={unit}/> */}
          <NewReservationButton Text={Text} />
          <DropdownProperties groups={filteredProperties}/>
          {/* <DrawerCTA unit={unit} /> */}
        </Box>
      </div>
      <PoweredBy />
      </Box>
        </Scrollbar>
    </Box>
  );
}

export default UnitDrawer;
